export function buildExpressionTree(expr) {
  if (!expr || !expr.TYPE) return null;

  switch (expr.TYPE) {
    case "LITERAL":
      return {
        type: "LITERAL",
        value: expr.VALUE,
        expression: expr.VALUE || "",
      };

    case "REFERENCE":
      return {
        type: "REFERENCE",
        value: expr.VALUE,
        expression: expr.VALUE || "",
      };

    case "OPERATION":
      const op = expr.OP || "+";

      // safely map over ARGS, skip nulls
      const processedArgs = (expr.ARGS || [])
        .map(buildExpressionTree) // recursively process
        .filter((arg) => arg != null); // remove any nulls

      // build expression string only if we have valid args
      const exprStr =
        processedArgs.length > 0
          ? `(${processedArgs.map((a) => a.expression || "").join(` ${op} `)})`
          : "";

      return {
        type: "OPERATION",
        op,
        expression: exprStr,
        args: processedArgs,
      };

    default:
      return null;
  }
}
